import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Pagination from '@hydra/common/components/Pagination';
import CrawlerBody from './TableBody';
import CrawlerTableHead from './TableHead';

import toArray from '@hydra/utils/toArray';
import mustHaveChildren from './mustHaveChildren';
import Icon from '@hydra/common/components/Icon';

import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
    margin: theme.spacing(3, 2)
  },
  backdrop: {
    zIndex: theme.zIndex.appBar - 3
  }
}));

const PaginationContainer = ({ children, ...props }) => {
  const classes = useStyles();
  return (
    <div className={classnames(classes.pagination, classes.backdrop)}>
      {children}
    </div>
  );
};

const BackdropContainer = ({ open, ...props }) => {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={open}>
      <Icon type='loader' size='lg' color='white' />
    </Backdrop>
  );
};

export default class CrawlerTable extends React.PureComponent {
  static propTypes = {
    ...mustHaveChildren,
    relay: PropTypes.object.isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number,
    section: PropTypes.string.isRequired,
    project: PropTypes.object.isRequired
  }

  static Body = CrawlerBody;
  static TableHead = CrawlerTableHead;

  getColumnSizes (children) {
    const childrenArray = toArray(children);
    const filterIndex = childrenArray.findIndex(child => CrawlerTableHead === child.type);
    const filters = childrenArray[filterIndex];

    if (!filters || !filters.props.children) {
      return null;
    }

    return toArray(filters.props.children).map(child => child.props.size);
  }

  render () {
    const { relay, section } = this.props;

    const offset = get(this.props, 'offset', get(this.props, ['relay', 'variables', 'offset'], 0));
    const limit = get(this.props, 'limit', get(this.props, ['relay', 'variables', 'limit'], 10));
    const total = get(this.props, `project.crawls.edges[0].node.${section}.count`, 0);
    const host = get(this.props, 'project.host', null);

    const nodes = get(this.props, `project.crawls.edges[0].node.${section}.edges`, [])
      .map(edge => edge.node)
      .map(node => ({ ...node, id: (node.id || node.__id) }));

    const columns = this.getColumnSizes(this.props.children);

    return (
      <div className='nr-crawler-issue-table'>
        <BackdropContainer open={this.props.loading} />
        {
          React.Children.map(this.props.children,
            child => React.cloneElement(child,
              child.type === CrawlerBody
                ? { relay, columns, offset, limit, total, nodes, host }
                : { relay, host }
            )
          )
        }
        {
          total > this.props.limit
            ? (
              <PaginationContainer>
                <Pagination
                  currentPage={this.props.offset / this.props.limit}
                  onPagination={this.props.onPagination}
                  step={this.props.limit}
                  totalItems={total}
                />
              </PaginationContainer>
              )
            : null
        }
      </div>
    );
  }
}
